const OrganisationNavigationQueryParameters = {
  OrganisationUnitId: 'organisationUnitId',
} as const;

export default OrganisationNavigationQueryParameters;
